export default "__VITE_ASSET__8ce04848__"